import Delivery1 from '@/components/Icons/TimelineIcons/Delivery1';
import Delivery10 from '@/components/Icons/TimelineIcons/Delivery10';
import Delivery11 from '@/components/Icons/TimelineIcons/Delivery11';
import Delivery12 from '@/components/Icons/TimelineIcons/Delivery12';
import Delivery13 from '@/components/Icons/TimelineIcons/Delivery13';
import Delivery14 from '@/components/Icons/TimelineIcons/Delivery14';
import Delivery15 from '@/components/Icons/TimelineIcons/Delivery15';
import Delivery16 from '@/components/Icons/TimelineIcons/Delivery16';
import Delivery17 from '@/components/Icons/TimelineIcons/Delivery17';
import Delivery18 from '@/components/Icons/TimelineIcons/Delivery18';
import Delivery19 from '@/components/Icons/TimelineIcons/Delivery19';
import Delivery2 from '@/components/Icons/TimelineIcons/Delivery2';
import Delivery20 from '@/components/Icons/TimelineIcons/Delivery20';
import Delivery21 from '@/components/Icons/TimelineIcons/Delivery21';
import Delivery22 from '@/components/Icons/TimelineIcons/Delivery22';
import Delivery23 from '@/components/Icons/TimelineIcons/Delivery23';
import Delivery3 from '@/components/Icons/TimelineIcons/Delivery3';
import Delivery4 from '@/components/Icons/TimelineIcons/Delivery4';
import Delivery5 from '@/components/Icons/TimelineIcons/Delivery5';
import Delivery6 from '@/components/Icons/TimelineIcons/Delivery6';
import Delivery7 from '@/components/Icons/TimelineIcons/Delivery7';
import Delivery8 from '@/components/Icons/TimelineIcons/Delivery8';
import Delivery9 from '@/components/Icons/TimelineIcons/Delivery9';
import Location1 from '@/components/Icons/TimelineIcons/Location1';
import Location10 from '@/components/Icons/TimelineIcons/Location10';
import Location11 from '@/components/Icons/TimelineIcons/Location11';
import Location12 from '@/components/Icons/TimelineIcons/Location12';
import Location13 from '@/components/Icons/TimelineIcons/Location13';
import Location14 from '@/components/Icons/TimelineIcons/Location14';
import Location15 from '@/components/Icons/TimelineIcons/Location15';
import Location16 from '@/components/Icons/TimelineIcons/Location16';
import Location17 from '@/components/Icons/TimelineIcons/Location17';
import Location18 from '@/components/Icons/TimelineIcons/Location18';
import Location19 from '@/components/Icons/TimelineIcons/Location19';
import Location2 from '@/components/Icons/TimelineIcons/Location2';
import Location20 from '@/components/Icons/TimelineIcons/Location20';
import Location21 from '@/components/Icons/TimelineIcons/Location21';
import Location3 from '@/components/Icons/TimelineIcons/Location3';
import Location4 from '@/components/Icons/TimelineIcons/Location4';
import Location5 from '@/components/Icons/TimelineIcons/Location5';
import Location6 from '@/components/Icons/TimelineIcons/Location6';
import Location7 from '@/components/Icons/TimelineIcons/Location7';
import Location8 from '@/components/Icons/TimelineIcons/Location8';
import Location9 from '@/components/Icons/TimelineIcons/Location9';
import Order1 from '@/components/Icons/TimelineIcons/Order1';
import Order10 from '@/components/Icons/TimelineIcons/Order10';
import Order11 from '@/components/Icons/TimelineIcons/Order11';
import Order12 from '@/components/Icons/TimelineIcons/Order12';
import Order13 from '@/components/Icons/TimelineIcons/Order13';
import Order14 from '@/components/Icons/TimelineIcons/Order14';
import Order15 from '@/components/Icons/TimelineIcons/Order15';
import Order16 from '@/components/Icons/TimelineIcons/Order16';
import Order17 from '@/components/Icons/TimelineIcons/Order17';
import Order18 from '@/components/Icons/TimelineIcons/Order18';
import Order19 from '@/components/Icons/TimelineIcons/Order19';
import Order2 from '@/components/Icons/TimelineIcons/Order2';
import Order20 from '@/components/Icons/TimelineIcons/Order20';
import Order21 from '@/components/Icons/TimelineIcons/Order21';
import Order22 from '@/components/Icons/TimelineIcons/Order22';
import Order3 from '@/components/Icons/TimelineIcons/Order3';
import Order4 from '@/components/Icons/TimelineIcons/Order4';
import Order5 from '@/components/Icons/TimelineIcons/Order5';
import Order6 from '@/components/Icons/TimelineIcons/Order6';
import Order7 from '@/components/Icons/TimelineIcons/Order7';
import Order8 from '@/components/Icons/TimelineIcons/Order8';
import Order9 from '@/components/Icons/TimelineIcons/Order9';
import Prepare1 from '@/components/Icons/TimelineIcons/Prepare1';
import Prepare10 from '@/components/Icons/TimelineIcons/Prepare10';
import Prepare11 from '@/components/Icons/TimelineIcons/Prepare11';
import Prepare12 from '@/components/Icons/TimelineIcons/Prepare12';
import Prepare13 from '@/components/Icons/TimelineIcons/Prepare13';
import Prepare14 from '@/components/Icons/TimelineIcons/Prepare14';
import Prepare15 from '@/components/Icons/TimelineIcons/Prepare15';
import Prepare16 from '@/components/Icons/TimelineIcons/Prepare16';
import Prepare17 from '@/components/Icons/TimelineIcons/Prepare17';
import Prepare18 from '@/components/Icons/TimelineIcons/Prepare18';
import Prepare19 from '@/components/Icons/TimelineIcons/Prepare19';
import Prepare2 from '@/components/Icons/TimelineIcons/Prepare2';
import Prepare20 from '@/components/Icons/TimelineIcons/Prepare20';
import Prepare21 from '@/components/Icons/TimelineIcons/Prepare21';
import Prepare22 from '@/components/Icons/TimelineIcons/Prepare22';
import Prepare3 from '@/components/Icons/TimelineIcons/Prepare3';
import Prepare4 from '@/components/Icons/TimelineIcons/Prepare4';
import Prepare5 from '@/components/Icons/TimelineIcons/Prepare5';
import Prepare6 from '@/components/Icons/TimelineIcons/Prepare6';
import Prepare7 from '@/components/Icons/TimelineIcons/Prepare7';
import Prepare8 from '@/components/Icons/TimelineIcons/Prepare8';
import Prepare9 from '@/components/Icons/TimelineIcons/Prepare9';
import { EmojiIconId, TimeLineIconId, TimelineIconsEnum } from '@/constants/enum';

export const emojiIcons = [
  {
    id: 0,
    title: 'Time',
    icons: [
      { id: EmojiIconId.Time1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time1.png' },
      { id: EmojiIconId.Time2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time2.png' },
      { id: EmojiIconId.Time3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time3.png' },
      { id: EmojiIconId.Time4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time4.png' },
      { id: EmojiIconId.Time5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time5.png' },
      { id: EmojiIconId.Time6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time6.png' },
      { id: EmojiIconId.Time7, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time7.png' },
      { id: EmojiIconId.Time8, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/time8.png' },
      {
        id: EmojiIconId.Time9,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time1.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time10,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time2.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time11,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time3.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time12,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time4.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time13,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time5.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time14,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time6.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Time15,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/time7.gif',
        width: 25,
        height: 25,
      },
    ],
  },
  {
    id: 1,
    title: 'Deals, Voucher',
    icons: [
      { id: EmojiIconId.Deal1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal1.png' },
      { id: EmojiIconId.Deal2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal2.png' },
      { id: EmojiIconId.Deal3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal3.png' },
      { id: EmojiIconId.Deal4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal4.png' },
      { id: EmojiIconId.Deal5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal5.png' },
      { id: EmojiIconId.Deal6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/deal6.png' },
      {
        id: EmojiIconId.Deal7,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal1.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Deal8,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal2.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Deal9,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal3.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Deal10,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal4.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Deal11,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal5.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Deal12,
        source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal/deal6.gif',
        width: 25,
        height: 25,
      },
    ],
  },
  {
    id: 2,
    title: 'Order, Receipt',
    icons: [
      { id: EmojiIconId.Order1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order1.png' },
      { id: EmojiIconId.Order2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order2.png' },
      { id: EmojiIconId.Order3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order3.png' },
      { id: EmojiIconId.Order4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order4.png' },
      { id: EmojiIconId.Order5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order5.png' },
      { id: EmojiIconId.Order6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order6.png' },
      { id: EmojiIconId.Order7, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order7.png' },
      { id: EmojiIconId.Order8, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order8.png' },
      { id: EmojiIconId.Order9, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order9.png' },
      { id: EmojiIconId.Order10, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order10.png' },
      { id: EmojiIconId.Order11, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order11.png' },
      { id: EmojiIconId.Order12, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order12.png' },
      { id: EmojiIconId.Order13, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/order13.png' },
      { id: EmojiIconId.Order14, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/order14.png' },
      { id: EmojiIconId.Order15, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/order15.png' },
      { id: EmojiIconId.Order16, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/order16.png' },
      { id: EmojiIconId.Order17, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/order17.png' },
      { id: EmojiIconId.Order18, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/order18.png' },
      {
        id: EmojiIconId.Order19,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/order19.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Order20,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/order20.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Order21,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/order21.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Order21,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/order22.gif',
        width: 25,
        height: 25,
      },
    ],
  },
  {
    id: 3,
    title: 'Prepare, Process, Produce, Package',
    icons: [
      { id: EmojiIconId.Prepare1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare1.png' },
      { id: EmojiIconId.Prepare2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare2.png' },
      { id: EmojiIconId.Prepare3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare3.png' },
      { id: EmojiIconId.Prepare4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare4.png' },
      { id: EmojiIconId.Prepare5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare5.png' },
      { id: EmojiIconId.Prepare6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare6.png' },
      { id: EmojiIconId.Prepare7, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare7.png' },
      { id: EmojiIconId.Prepare8, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/prepare8.png' },
      { id: EmojiIconId.Prepare9, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/prepare9.png' },
      { id: EmojiIconId.Prepare10, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/prepare10.png' },
      { id: EmojiIconId.Prepare11, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/prepare11.png' },
      { id: EmojiIconId.Prepare12, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/prepare12.png' },
      {
        id: EmojiIconId.Prepare13,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare17.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Prepare14,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare18.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Prepare15,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare19.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Prepare16,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare20.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Prepare17,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare21.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Prepare18,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/prepare22.gif',
        width: 25,
        height: 25,
      },
    ],
  },
  {
    id: 4,
    title: 'Dispatch, Delivery',
    icons: [
      { id: EmojiIconId.Delivery1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery1.png' },
      { id: EmojiIconId.Delivery2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery2.png' },
      { id: EmojiIconId.Delivery3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery3.png' },
      { id: EmojiIconId.Delivery4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery4.png' },
      { id: EmojiIconId.Delivery5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery5.png' },
      { id: EmojiIconId.Delivery6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery6.png' },
      { id: EmojiIconId.Delivery7, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery7.png' },
      { id: EmojiIconId.Delivery8, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery8.png' },
      { id: EmojiIconId.Delivery9, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery9.png' },
      { id: EmojiIconId.Delivery10, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery10.png' },
      { id: EmojiIconId.Delivery11, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/delivery12.png' },
      { id: EmojiIconId.Delivery12, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/deliver12.png' },
      { id: EmojiIconId.Delivery13, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/deliver13.png' },
      { id: EmojiIconId.Delivery14, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/deliver14.png' },
      { id: EmojiIconId.Delivery15, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/deliver15.png' },
      {
        id: EmojiIconId.Delivery16,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery18.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Delivery17,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery19.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Delivery18,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery20.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Delivery19,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery21.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Delivery20,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery22.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Delivery21,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/delivery23.gif',
        width: 25,
        height: 25,
      },
    ],
  },
  {
    id: 5,
    title: 'Location, Facility',
    icons: [
      { id: EmojiIconId.Location1, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location1.png' },
      { id: EmojiIconId.Location2, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location2.png' },
      { id: EmojiIconId.Location3, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location3.png' },
      { id: EmojiIconId.Location4, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location4.png' },
      { id: EmojiIconId.Location5, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location5.png' },
      { id: EmojiIconId.Location6, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location6.png' },
      { id: EmojiIconId.Location7, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location7.png' },
      { id: EmojiIconId.Location8, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location8.png' },
      { id: EmojiIconId.Location9, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location9.png' },
      { id: EmojiIconId.Location10, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location10.png' },
      { id: EmojiIconId.Location11, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location11.png' },
      { id: EmojiIconId.Location12, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location12.png' },
      { id: EmojiIconId.Location13, source: 'https://media.synctrack.io/megamind-estimated/asset/timedeal2/location13.png' },
      { id: EmojiIconId.Location14, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/location14.png' },
      { id: EmojiIconId.Location15, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/location15.png' },
      { id: EmojiIconId.Location16, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/location16.png' },
      { id: EmojiIconId.Location17, source: 'https://media.synctrack.io/megamind-estimated/icon/icon_color/location17.png' },
      {
        id: EmojiIconId.Location18,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/location18.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Location19,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/location19.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Location20,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/location20.gif',
        width: 25,
        height: 25,
      },
      {
        id: EmojiIconId.Location21,
        source: 'https://media.synctrack.io/megamind-estimated/icon-timeline/location21.gif',
        width: 25,
        height: 25,
      },
    ],
  },
];

export const timelineIcons = [
  {
    id: TimelineIconsEnum.Order,
    title: 'Order, Receipt',
    icons: [
      { id: TimeLineIconId.Order1, icon: <Order1 /> },
      { id: TimeLineIconId.Order2, icon: <Order2 /> },
      { id: TimeLineIconId.Order3, icon: <Order3 /> },
      { id: TimeLineIconId.Order4, icon: <Order4 /> },
      { id: TimeLineIconId.Order5, icon: <Order5 /> },
      { id: TimeLineIconId.Order6, icon: <Order6 /> },
      { id: TimeLineIconId.Order7, icon: <Order7 /> },
      { id: TimeLineIconId.Order8, icon: <Order8 /> },
      { id: TimeLineIconId.Order9, icon: <Order9 /> },
      { id: TimeLineIconId.Order10, icon: <Order10 /> },
      { id: TimeLineIconId.Order11, icon: <Order11 /> },
      { id: TimeLineIconId.Order12, icon: <Order12 /> },
      { id: TimeLineIconId.Order13, icon: <Order13 /> },
      { id: TimeLineIconId.Order14, icon: <Order14 /> },
      { id: TimeLineIconId.Order15, icon: <Order15 /> },
      { id: TimeLineIconId.Order16, icon: <Order16 /> },
      { id: TimeLineIconId.Order17, icon: <Order17 /> },
      { id: TimeLineIconId.Order18, icon: <Order18 /> },
      { id: TimeLineIconId.Order19, icon: <Order19 /> },
      { id: TimeLineIconId.Order20, icon: <Order20 /> },
      { id: TimeLineIconId.Order21, icon: <Order21 /> },
      { id: TimeLineIconId.Order22, icon: <Order22 /> },
    ],
  },
  {
    id: TimelineIconsEnum.Prepare,
    title: 'Prepare, Process, Produce, Package',
    icons: [
      { id: TimeLineIconId.Prepare1, icon: <Prepare1 /> },
      { id: TimeLineIconId.Prepare2, icon: <Prepare2 /> },
      { id: TimeLineIconId.Prepare3, icon: <Prepare3 /> },
      { id: TimeLineIconId.Prepare4, icon: <Prepare4 /> },
      { id: TimeLineIconId.Prepare5, icon: <Prepare5 /> },
      { id: TimeLineIconId.Prepare6, icon: <Prepare6 /> },
      { id: TimeLineIconId.Prepare7, icon: <Prepare7 /> },
      { id: TimeLineIconId.Prepare8, icon: <Prepare8 /> },
      { id: TimeLineIconId.Prepare9, icon: <Prepare9 /> },
      { id: TimeLineIconId.Prepare10, icon: <Prepare10 /> },
      { id: TimeLineIconId.Prepare11, icon: <Prepare11 /> },
      { id: TimeLineIconId.Prepare12, icon: <Prepare12 /> },
      { id: TimeLineIconId.Prepare13, icon: <Prepare13 /> },
      { id: TimeLineIconId.Prepare14, icon: <Prepare14 /> },
      { id: TimeLineIconId.Prepare15, icon: <Prepare15 /> },
      { id: TimeLineIconId.Prepare16, icon: <Prepare16 /> },
      { id: TimeLineIconId.Prepare17, icon: <Prepare17 /> },
      { id: TimeLineIconId.Prepare18, icon: <Prepare18 /> },
      { id: TimeLineIconId.Prepare19, icon: <Prepare19 /> },
      { id: TimeLineIconId.Prepare20, icon: <Prepare20 /> },
      { id: TimeLineIconId.Prepare21, icon: <Prepare21 /> },
      { id: TimeLineIconId.Prepare22, icon: <Prepare22 /> },
    ],
  },
  {
    id: TimelineIconsEnum.Delivery,
    title: 'Dispatch, Delivery',
    icons: [
      { id: TimeLineIconId.Delivery1, icon: <Delivery1 /> },
      { id: TimeLineIconId.Delivery2, icon: <Delivery2 /> },
      { id: TimeLineIconId.Delivery3, icon: <Delivery3 /> },
      { id: TimeLineIconId.Delivery4, icon: <Delivery4 /> },
      { id: TimeLineIconId.Delivery5, icon: <Delivery5 /> },
      { id: TimeLineIconId.Delivery6, icon: <Delivery6 /> },
      { id: TimeLineIconId.Delivery7, icon: <Delivery7 /> },
      { id: TimeLineIconId.Delivery8, icon: <Delivery8 /> },
      { id: TimeLineIconId.Delivery9, icon: <Delivery9 /> },
      { id: TimeLineIconId.Delivery10, icon: <Delivery10 /> },
      { id: TimeLineIconId.Delivery11, icon: <Delivery11 /> },
      { id: TimeLineIconId.Delivery12, icon: <Delivery12 /> },
      { id: TimeLineIconId.Delivery13, icon: <Delivery13 /> },
      { id: TimeLineIconId.Delivery14, icon: <Delivery14 /> },
      { id: TimeLineIconId.Delivery15, icon: <Delivery15 /> },
      { id: TimeLineIconId.Delivery16, icon: <Delivery16 /> },
      { id: TimeLineIconId.Delivery17, icon: <Delivery17 /> },
      { id: TimeLineIconId.Delivery18, icon: <Delivery18 /> },
      { id: TimeLineIconId.Delivery19, icon: <Delivery19 /> },
      { id: TimeLineIconId.Delivery20, icon: <Delivery20 /> },
      { id: TimeLineIconId.Delivery21, icon: <Delivery21 /> },
      { id: TimeLineIconId.Delivery22, icon: <Delivery22 /> },
      { id: TimeLineIconId.Delivery23, icon: <Delivery23 /> },
    ],
  },
  {
    id: TimelineIconsEnum.Location,
    title: 'Location, Facility',
    icons: [
      { id: TimeLineIconId.Location1, icon: <Location1 /> },
      { id: TimeLineIconId.Location2, icon: <Location2 /> },
      { id: TimeLineIconId.Location3, icon: <Location3 /> },
      { id: TimeLineIconId.Location4, icon: <Location4 /> },
      { id: TimeLineIconId.Location5, icon: <Location5 /> },
      { id: TimeLineIconId.Location6, icon: <Location6 /> },
      { id: TimeLineIconId.Location7, icon: <Location7 /> },
      { id: TimeLineIconId.Location8, icon: <Location8 /> },
      { id: TimeLineIconId.Location9, icon: <Location9 /> },
      { id: TimeLineIconId.Location10, icon: <Location10 /> },
      { id: TimeLineIconId.Location11, icon: <Location11 /> },
      { id: TimeLineIconId.Location12, icon: <Location12 /> },
      { id: TimeLineIconId.Location13, icon: <Location13 /> },
      { id: TimeLineIconId.Location14, icon: <Location14 /> },
      { id: TimeLineIconId.Location15, icon: <Location15 /> },
      { id: TimeLineIconId.Location16, icon: <Location16 /> },
      { id: TimeLineIconId.Location17, icon: <Location17 /> },
      { id: TimeLineIconId.Location18, icon: <Location18 /> },
      { id: TimeLineIconId.Location19, icon: <Location19 /> },
      { id: TimeLineIconId.Location20, icon: <Location20 /> },
      { id: TimeLineIconId.Location21, icon: <Location21 /> },
    ],
  },
];
